import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import zh from "./locales/zh.json";
import vi from "./locales/vi.json";
import pt from "./locales/pt.json";
import de from "./locales/de.json";
import nl from "./locales/nl.json";
import ja from "./locales/ja.json";

export const LANGUAGES = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
  { code: "vi", label: "Tiếng Việt", flag: "🇻🇳" },
];

// Robots d'indexation (Googlebot, Bingbot, robots des moteurs IA…) : la langue vient de l'URL seulement. Sans cela,
// Googlebot (navigateur en anglais) rendait l'accueil français en anglais, alors que la page déclare
// hreflang="fr" et canonical « / ». `/` = français, `/?lang=en` = anglais, etc. (voir les hreflang de usePageMeta).
const IS_CRAWLER =
  typeof navigator !== "undefined" &&
  /bot|crawl|spider|slurp|mediapartners|facebookexternalhit|embedly|quora link preview|outbrain|pinterest|vkshare|w3c_validator|lighthouse|headlesschrome/i.test(
    navigator.userAgent || "",
  );

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
      it: { translation: it },
      zh: { translation: zh },
      vi: { translation: vi },
      pt: { translation: pt },
      de: { translation: de },
      nl: { translation: nl },
      ja: { translation: ja },
    },
    fallbackLng: "fr",
    supportedLngs: LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      // ?lang=xx en premier : les URL déclarées en hreflang affichent bien leur langue (et la mémorisent).
      order: IS_CRAWLER ? ["querystring"] : ["querystring", "localStorage", "navigator"],
      caches: IS_CRAWLER ? [] : ["localStorage"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "flowgantt_lang",
    },
  });

// Keep <html lang="..."> in sync with the active language for SEO / a11y.
const applyHtmlLang = (lng) => {
  if (typeof document !== "undefined" && lng) {
    document.documentElement.setAttribute("lang", lng);
  }
};
applyHtmlLang(i18n.language);
i18n.on("languageChanged", applyHtmlLang);

export default i18n;
